// @charset "utf-8";
import { logRequest, transformResponse } from './utils'

// API接口描述
const descriptionMap = {
    queryAccount: '查询资金账户',
    addAccount: '新增资金账户',
    deleteAccount: '删除资金账户',
    bindAccount: '绑定资金账户',
    unbindAccount: '解绑资金账户',
    modifyAccount: '编辑账户信息',
    loginAccount: '登录资金账户',
    logoutAccount: '注销资金账户',
    queryAccountGroup: '查询客户端资金账户组',
    addAccountGroup: '添加账户组',
    deleteAccountGroup: '删除账户组',
    addAccountToGroup: '账户组添加资金账户',
    deleteAccountFromGroup: '账户组删除资金账户'
}

const apiMap = {
    queryAccount: 'getAccountList',
    addAccount: 'addAccount',
    deleteAccount: 'deleteAccount',
    bindAccount: 'bindAccount',
    unbindAccount: 'unbindAccount',
    modifyAccount: 'editAccount',
    modifyAccountPassword: 'editPassword',
    loginAccount: 'refreshSelAccountList',
    logoutAccount: 'logoutAccount',
    queryAccountGroup: 'getGroupList',
    addAccountGroup: 'addAccountGroup',
    deleteAccountGroup: 'deleteAccountGroup',
    addAccountToGroup: 'addAccountToGroup',
    deleteAccountFromGroup: 'deleteAccountFromGroup'
}

function generateFuncs () {
    const exportFuncs = {}

    Object.keys(apiMap).forEach(funcName => {
        const apiName = apiMap[funcName]
        const description = descriptionMap[funcName]
        exportFuncs[funcName] = (params = {}) => {
            params = {
                command: apiName,
                from: 'PageAccountManager',
                ...params
            }
            logRequest({ params, apiName, description })
            return new Promise((resolve, reject) => {
                window.cef.NotifyUIEvent({
                    subkey: 'cmd_accountmanager',
                    data: JSON.stringify(params)
                }, data => {
                    data = JSON.parse(data)
                    const { status, result, error } = transformResponse({ params, res: data, apiName, description })
                    if (status) {
                        // if (result[0] && Object.values(result[0]).length === 1) {
                        //     const tmp = Object.values(result[0])[0]
                        //     if (tmp.code === 0) {
                        //         resolve(tmp)
                        //     } else {
                        //         reject(tmp)
                        //     }
                        // } else {
                        resolve(...result)
                    } else {
                        reject(error)
                    }
                }, error => {
                    transformResponse({ params, res: { error }, apiName, description })
                    reject(error)
                })
            })
        }
    })
    return exportFuncs
}

export default generateFuncs()



// WEBPACK FOOTER //
// ./src/api/account.js